.wrapper {
  background: var(--color-cool-gray);
  padding: var(--padding);

  &.isLoading {
    pointer-events: none;
  }

  &.fullscreen {
    background: white;
    border-radius: 0;
  }

  @media (--lg) {
    &.fullscreen {
      overflow-y: auto;
      height: 100vh;
    }
  }

  @media (--lg) {
    border-radius: var(--border-radius-large) var(--border-radius-large) 0 0;
    &.noRadius {
      border-radius: 0;
    }
  }
}
